import { render, staticRenderFns } from "./FormOtpGifty.vue?vue&type=template&id=d73e77f4"
import script from "./FormOtpGifty.vue?vue&type=script&lang=js"
export * from "./FormOtpGifty.vue?vue&type=script&lang=js"
import style0 from "./FormOtpGifty.vue?vue&type=style&index=0&id=d73e77f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports